import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import {
    AisRestService,
    AttributeType,
    BaseQuestionIdentifier,
    ConditionDisclosureResource,
    DateElement,
    EmbeddableResourceNames,
    ListDefinitionResource,
    ListItemResource,
    LocationToIdentifierHelper,
    QuestionType,
    ScreensQuestionResource
} from '@Components/mras/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'jhi-question-case-data',
    templateUrl: './question-case-data.component.html',
    styles: []
})
export class QuestionCaseDataComponent implements OnInit, OnChanges {
    readonly AttributeType = AttributeType;
    readonly QuestionType = QuestionType;
    readonly DateElement = DateElement;
    private identifier: BaseQuestionIdentifier;

    @Input()
        summaryMode: boolean;
    @Input()
        question: ScreensQuestionResource;
    @Output()
        questionChange = new EventEmitter<ScreensQuestionResource>();

    @Input()
        questionIdentifier: BaseQuestionIdentifier;
    @Input()
        embedded: [EmbeddableResourceNames, any[]];
    @Output()
        onEmbeddedChange = new EventEmitter<[EmbeddableResourceNames, any[]]>();

    @Output()
        onQuestionChange = new EventEmitter<BaseQuestionIdentifier>();

    answerValue: any;

    answerPlaceholder: string;
    answerOptions: ListItemResource[];
    httpErrorMsg: string;

    constructor(
        private aisRestService: AisRestService,
        private locationToIdentifier: LocationToIdentifierHelper,
        private route: ActivatedRoute
    ) {}

    ngOnChanges() {
        this.answerValue = this.question.answerValue;
    }

    ngOnInit() {
        this.identifier = new BaseQuestionIdentifier();
        this.identifier.caseId = this.locationToIdentifier.identifier.caseId;
        this.identifier.lifeInstance = this.locationToIdentifier.identifier.lifeInstance;
        this.identifier.interviewCode = this.locationToIdentifier.identifier.interviewCode;
        this.identifier.interviewInstance = this.locationToIdentifier.identifier.interviewInstance;
        this.identifier.baseQuestionCode = this.question.code;

        this.answerValue = this.question.answerValue;
        if (this.question.caseDataQuestionMeta.unit != null) {
            this.answerPlaceholder = `Provide answer in ${this.question.caseDataQuestionMeta.unit}`;
        }
        if (this.question.caseDataQuestionMeta.dataType === AttributeType.DATE) {
            this.answerPlaceholder = 'yyyy-mm-dd';
        }
        if (
            this.question.caseDataQuestionMeta.dataType === AttributeType.MULTISELECTION ||
            this.question.caseDataQuestionMeta.dataType === AttributeType.SELECTION
        ) {
            const listName = this.question.caseDataQuestionMeta.list.listName;
            this.answerOptions = this.embedded[EmbeddableResourceNames.LISTS]
                .map(e => e as ListDefinitionResource)
                .find(e => e.listName === listName).listItems;
        }
    }

    answer() {
        const resource = new ScreensQuestionResource();
        resource.answerValue = this.answerValue;
        this.question.answerValue = this.answerValue;
        this.httpErrorMsg = null;
        this.aisRestService.answerBaseQuestion(this.identifier, resource).subscribe(
            response => {
                if (response.errorCode && response.errorCode !== '') {
                    this.httpErrorMsg = response.errorCode;
                    return;
                }

                Object.keys(this.question).forEach(f => delete this.question[f]);
                Object.assign(this.question, response);
                this.questionChange.emit(this.question);
                (response._embedded[EmbeddableResourceNames.AFFECTED_QUESTIONS] || []).forEach(f => {
                    this.onQuestionChange.emit(f);
                });
                if (response._embedded[EmbeddableResourceNames.DISCLOSURES] != null) {
                    const oldDisclosures = this.embedded[EmbeddableResourceNames.DISCLOSURES] as ConditionDisclosureResource[];
                    response._embedded[EmbeddableResourceNames.DISCLOSURES].forEach(nd => {
                        const existingDisclosure = (oldDisclosures || []).find(od => od.aliasName === nd.aliasName);
                        if (existingDisclosure != null) {
                            Object.keys(existingDisclosure).forEach(f => delete existingDisclosure[f]);
                            Object.assign(existingDisclosure, nd);
                        } else {
                            oldDisclosures.push(nd);
                        }
                    });
                    this.onEmbeddedChange.emit(this.embedded);
                }
            },
            errMsg => (this.httpErrorMsg = errMsg)
        );
    }

    toOptionValue(val: ListItemResource): string {
        return val.code;
    }

    toOptionLabel(val: ListItemResource): string {
        return val.description;
    }
}
